import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Button, Spinner, Modal, ModalHeader, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function Timer() {


  return (
    <>
      <Col className="bordered d-grid gap-2">
        <Row className="itemTitle">
          <h2>Timer!</h2>
        </Row>
        <Row className="timerButton">
          <Button as={Link} to="/timer" size="lg">
            Use the Timer
          </Button>
        </Row>

        <hr />
        <Row>
          <Col>

          </Col>
        </Row>
      </Col>
    </>
  );
}

export default Timer;
